

function ShowCartCount(variant_id){
   var xhttp = new XMLHttpRequest();
   xhttp.onreadystatechange = function() {
     if (this.readyState == 4 && this.status == 200) {
       var cart = JSON.parse(this.responseText);
       var item_id = variant_id

        
        document.querySelector('#myTextcoun').innerText = (cart.item_count);
        $('.sucess-'+item_id).addClass('succ_1')
        $('.maintex-'+item_id).addClass('main_cl')
  
            setTimeout(function () { 
             
               $('.sucess-'+item_id).removeClass('succ_1')
                $('.maintex-'+item_id).removeClass('main_cl')
            }, 4000);
     }
   };
   xhttp.open("GET", "/cart.js", true);
   xhttp.setRequestHeader("Content-Type", "application/json;");
   xhttp.send();
}
function addItemToCart(variant_id, qty) {
  
  var data = {"id": variant_id,"quantity": qty}
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      ShowCartCount(variant_id);
    }
  };
  xhttp.open("POST", "/cart/add.js", true);
  xhttp.setRequestHeader("Content-Type", "application/json;");
  xhttp.send(JSON.stringify(data));

 
}


// document.addEventListener('click', function (e) {
//   const btn = e.target.closest('.wishlist-btn');
//   if (!btn) return;
//   btn.classList.toggle('is-active');
// });
function initWishlist(){

  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  const badge = document.getElementById("wishlist-count");

  function updateWishlistCount(){
    if(badge){
      badge.textContent = wishlist.length;
    }
  }

  updateWishlistCount();

  document.querySelectorAll(".wishlist-btn").forEach(btn => {

    const id = btn.dataset.productId;

    // Prevent duplicate click events
    if(btn.classList.contains("wishlist-loaded")) return;
    btn.classList.add("wishlist-loaded");

    if (wishlist.includes(id)) {
      btn.classList.add("active");
    }

    btn.addEventListener("click", function (e) {

      e.preventDefault();
      e.stopPropagation();

      if (wishlist.includes(id)) {

        wishlist = wishlist.filter(item => item !== id);
        btn.classList.remove("active");

      } else {

        wishlist.push(id);
        btn.classList.add("active");

      }

      localStorage.setItem("wishlist", JSON.stringify(wishlist));

      updateWishlistCount();
    });

  });

}

// Run on first load
document.addEventListener("DOMContentLoaded", initWishlist);

// ⭐ VERY IMPORTANT for Shopify dynamic sections
document.addEventListener("shopify:section:load", initWishlist);






//cart count
document.addEventListener('DOMContentLoaded', function () {

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCount = document.querySelector('#cart-count');

        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }
      });
  }

  document.addEventListener('submit', function (event) {

    const form = event.target;

    if (form.matches('form[action="/cart/add"]')) {
      setTimeout(function () {
        updateCartCount();
      }, 500);
    }

  });

});